/* sg-sticky-buy — port of StickyBuyNowBanner. The fixed buy button is visible
   only when the hero, offer, AND footer are all out of view, tracked with an
   IntersectionObserver (same asymmetric thresholds as Hydrogen). */
(function () {
  var TARGETS = ['hero', 'offer', 'footer'];

  function init(banner) {
    var btn = banner.querySelector('[data-sg-stickybuy-btn]');
    var state = { hero: false, offer: false, footer: false };
    var els = {};
    banner.hidden = false; /* allow opacity transitions; stays invisible until is-visible */

    function update() {
      banner.classList.toggle('is-visible', !(state.hero || state.offer || state.footer));
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var name = entry.target.getAttribute('data-section');
        if (TARGETS.indexOf(name) === -1) return;
        var ratio = entry.intersectionRatio;
        var rect = entry.boundingClientRect;
        var rb = entry.rootBounds;
        var rootCenter = rb ? (rb.top + rb.bottom) / 2 : window.innerHeight / 2;
        var isBelow = (rect.top + rect.bottom) / 2 >= rootCenter;
        var threshold = isBelow ? 0.05 : 0.01;
        if (!state[name] && ratio >= threshold) state[name] = true;
        else if (state[name] && ratio < threshold) state[name] = false;
      });
      update();
    }, { rootMargin: '-12% 0px -12% 0px', threshold: [0.01, 0.05] });

    function observe(name) {
      if (els[name]) return els[name];
      var el = document.querySelector('[data-section="' + name + '"]');
      if (el) { els[name] = el; observer.observe(el); }
      return el;
    }

    var found = TARGETS.map(observe).filter(Boolean);
    if (!found.length) banner.classList.add('is-visible');

    /* Hero/offer may mount after this runs — attach when they appear. */
    if (found.length < TARGETS.length && typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        if (TARGETS.every(observe)) mo.disconnect();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }

    if (btn) {
      btn.addEventListener('click', function (e) {
        var href = btn.getAttribute('href');
        if (href && href.charAt(0) === '#') {
          var t = document.querySelector(href);
          if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-sg-stickybuy]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
